import {
    Configuration as DMSConfiguration
} from "./index";

export const Configuration = DMSConfiguration;
